import { SalesOfficeTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/sales-office-type.enum";

export const salesOfficeType = (type: SalesOfficeTypeEnum | string | number): string => {
    switch (type) {
        case SalesOfficeTypeEnum.PHYSICAL: return 'Físico';
        case SalesOfficeTypeEnum.ECOMMERCE: return 'E-commerce';
        case SalesOfficeTypeEnum.ROUTING: return 'Ruteo';
        case SalesOfficeTypeEnum.VIRTUAL: return 'Virtual';
        default: return ''; // Fallback 
    }
};
  